module.exports = __webpack_public_path__ + "static/media/tourisme.eea3823d.svg";